/** Permission required to access QA/QC screens and write QC feedback. */
export const PERMISSION_WRITE_QC = "WriteQC";

export function hasWriteQcPermission(store) {
  if (!store) return false;
  return store.getters["tenantId/hasPermission"](PERMISSION_WRITE_QC);
}
